"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = (0, _styles.styled)("div")({
  display: "block",
  boxSizing: "border-box"
});

var ContinuousColorScale = function ContinuousColorScale(_ref) {
  var schemaName = _ref.colors,
      _ref$points = _ref.points,
      points = _ref$points === void 0 ? 256 : _ref$points,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _ref$margin,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["colors", "points", "width", "height", "margin", "className"]);

  var canvasRef = (0, _react.useRef)(null);
  var colors = (0, _react.useMemo)(function () {
    return (0, _utils.getColors)(schemaName, points);
  }, [points, schemaName]);
  (0, _react.useEffect)(function () {
    var canvas = canvasRef.current;
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.display = "block";
    var context = canvas.getContext("2d");

    for (var i = 0; i < points; ++i) {
      context.fillStyle = colors[i];
      context.fillRect(i, 0, 1, 1);
    }
  }, [width, height, points, colors]);
  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    style: {
      width: width,
      height: height,
      paddingTop: margin.top,
      paddingRight: margin.right,
      paddingBottom: margin.bottom,
      paddingLeft: margin.left
    },
    className: (0, _clsx["default"])("HypScale-colors", "HypScale-continuous", className)
  }, props), /*#__PURE__*/_react["default"].createElement("canvas", {
    width: points,
    height: 1,
    ref: canvasRef
  }));
};

ContinuousColorScale.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContinuousColorScale",
  "props": {
    "points": {
      "defaultValue": {
        "value": "256",
        "computed": false
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false
    },
    "margin": {
      "defaultValue": {
        "value": "{ left: 0, right: 0, top: 0, bottom: 0 }",
        "computed": false
      },
      "required": false
    }
  }
};
var _default = ContinuousColorScale;
exports["default"] = _default;